import { Box, Button, Dialog, Theme, Typography } from '@mui/material'
import React, { useState } from 'react'
import OTPForm from '../../lib/formik/OtpForm'
import { useHistory, useRouteMatch } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { SuccessIcon } from '../../assets/SvgIcons';
import { USER_ROLES } from '../../utils/constant';
import { RootStateType } from '../../redux-store/reducers';
import { resendNomineeBSEValidateOtp, resendNomineeBSEValidateOtpRes, submitNomineeBSEValidateOtp, submitNomineeBSEValidateOtpRes } from '../../redux-store/actions/nominee';
import { showError } from '../../redux-store/actions/auth';
import { isRMLikeRole } from '../../utils/utilityFunctions';

export default function VerifyAddNomineeOtp(): JSX.Element {
    const { url } = useRouteMatch();
    const history = useHistory();
    const { cartId, id, message, token } = history.location.state as unknown as { cartId: string, id: string, message: string, token: string };
    const [otpMessage, setOtpMessage] = useState<string>(message ?? '');
    const dispatch = useDispatch();
    const [submitBSEPopup, setSubmitBSEPopup] = useState<boolean>(false);
    const { role = '' } = useSelector((store: RootStateType) => store.auth);
    const [validateOtpRes, setValidateOtpRes] = useState<submitNomineeBSEValidateOtpRes>({} as submitNomineeBSEValidateOtpRes);
    const [validationErrPopup, setValidationErrPopup] = useState<boolean>(false);
    const [validationErr, setValidationErr] = useState<string>('');

    const handleSubmit = async (otp: string) => {
        const payload = {
            otp,
            id,
            token
        }
        const validateRes = await (dispatch(submitNomineeBSEValidateOtp(payload)) as unknown as Promise<submitNomineeBSEValidateOtpRes>)
        // CORR-157: The early return in if (!validateRes?.isSuccess) makes the later
        // if (!validateRes?.isSuccess && validateRes?.isBseSuccess === false) block unreachable.
        // The validationErrPopup/BSE-failure dialog path is dead code. Accepted as-is; no logic change required.
        if (!validateRes?.isSuccess) {
            dispatch(showError(validateRes?.message ?? ""));
            return;
        }
        if (validateRes?.isSuccess) {
            setValidateOtpRes(validateRes);
            setSubmitBSEPopup(true);
        }
        if (!validateRes?.isSuccess && validateRes?.isBseSuccess === false) {
            setValidationErrPopup(true);
            setValidationErr(validateRes?.message ?? "");
            return;
        }
        else if (!validateRes?.isSuccess) {
            dispatch(showError(validateRes?.message ?? ""));
            return;
        }
        else if (validateRes?.isSuccess) {
            setSubmitBSEPopup(true);
        }

    };

    const handleResend = async () => {
        const payload = {
            token: token ?? "",
            id: id ? `${id}` : "",
        }

        const response = await (dispatch(resendNomineeBSEValidateOtp(payload)) as unknown as Promise<resendNomineeBSEValidateOtpRes>)

        if (response?.isSuccess) {
            setOtpMessage(response?.message ?? "");
            history.replace({
                pathname: url,
                state: { id: response?.id ?? "", cartId: response?.cartId ?? "", message: response?.message ?? "", token: response?.token ?? "" }
            });
        }
    }


    const redirectDashboard = () => {
        if (isRMLikeRole(role)) {
            history.replace('/dashboard');
        }
        else {
            history.replace('/investor-dashboard');
        }
    }
    return (
        <>
            <Box sx={{ padding: {xs:"10px 10px",sm:'30px 45px'} }}>
                <Typography
                    variant="h1"
                    sx={(theme: Theme) => ({
                        lineHeight: {xs:"20px",sm:"32.5px"},
                        color: theme.palette.text.primary
                    })}
                >
                    Verify Nominee Change Confirmation
                </Typography>
                <Box
                    sx={(theme: Theme) => ({
                        marginTop: "25px",
                        borderRadius: "20px",
                        backgroundColor: theme.palette.common.white,
                        padding: {xs:"10px",sm:"50px"},
                        boxShadow: `0px 4px 10px 0px ${theme.palette.common.black}0D`,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                    })}
                >
                    <Box sx={{ width: "50%" }}>
                        <OTPForm
                            onSubmit={handleSubmit}
                            onResend={handleResend}
                            otpMessage={otpMessage ?? ''}
                            warningMessage=""
                        />
                    </Box>
                </Box>
            </Box>
            <Dialog
                onClose={() => setSubmitBSEPopup(false)}
                open={submitBSEPopup}
                maxWidth='sm'
                sx={(theme: Theme) => ({
                    '& .MuiPaper-root': {
                        borderRadius: '12px',
                        backgroundColor: theme.palette.common.white,
                        padding: "24px",
                        width: "533px",
                    },
                })}
            >
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        rowGap: "48px"
                    }}
                >
                    <Box
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center",
                            paddingTop: "15px",
                            rowGap: "12px"
                        }}
                    >
                        <SuccessIcon />
                        {/* <Typography
                            variant="h2"
                            sx={(theme: Theme) => ({
                                lineHeight: "25px",
                                letterSpacing: "0.01px",
                                color: theme.palette.text.primary
                            })}
                        >
                            Submitted to BSE!
                        </Typography> */}
                        <Typography
                            variant="subtitle_400"
                            sx={(theme: Theme) => ({
                                lineHeight: "20px",
                                letterSpacing: "0.02px",
                                color: theme.palette.text.secondary,
                                textAlign: "center"
                            })}
                        >
                            {validateOtpRes?.message ?? ""}
                        </Typography>
                    </Box>
                    <Box>
                        <Button
                            variant="contained"
                            fullWidth
                            sx={(theme: Theme) => ({
                                borderRadius: "4px",
                                padding: "13px 20px",
                                backgroundColor: theme.palette.primary[500],
                                ...theme.typography.body_600,
                                fontSize: "16px",
                                lineHeight: "20px"
                            })}
                            onClick={redirectDashboard}
                        >
                            Go To Dashboard
                        </Button>
                    </Box>
                </Box>

            </Dialog>
            <Dialog
                onClose={() => setValidationErrPopup(false)}
                open={validationErrPopup}
                maxWidth='sm'
                sx={(theme: Theme) => ({
                    '& .MuiPaper-root': {
                        borderRadius: '12px',
                        backgroundColor: theme.palette.common.white,
                        padding: "24px",
                        width: "533px",
                    },
                })}
            >
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        rowGap: "48px"
                    }}
                >
                    <Box
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center",
                            paddingTop: "15px",
                            rowGap: "12px"
                        }}
                    >
                        {validationErr}
                    </Box>
                    <Box>
                        <Button
                            variant="contained"
                            fullWidth
                            sx={(theme: Theme) => ({
                                borderRadius: "4px",
                                padding: "13px 20px",
                                backgroundColor: theme.palette.primary[500],
                                ...theme.typography.body_600,
                                fontSize: "16px",
                                lineHeight: "20px"
                            })}
                            onClick={() => history.replace('/nominee/updateNominee')}
                        >
                            Go To Update Nominee
                        </Button>
                    </Box>
                </Box>

            </Dialog>
        </>
    )
}
